import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function formatTime(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatRelativeTime(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Agora';
  if (diffMins < 60) return `${diffMins}min`;
  if (diffHours < 24) return `${diffHours}h`;
  if (diffDays < 7) return `${diffDays}d`;
  return formatDate(dateString);
}

export function getStatusLabel(status) {
  const labels = {
    bot: 'No Bot',
    waiting: 'Aguardando',
    active: 'Em Atendimento',
    closed: 'Encerrada',
    closing: 'Encerrando',
  };
  return labels[status] || status;
}

export function getStatusColor(status) {
  const colors = {
    bot: 'bg-zinc-600 text-zinc-100',
    waiting: 'bg-yellow-500/20 text-yellow-400 border border-yellow-500/15',
    active: 'bg-green-500/20 text-green-400 border border-green-500/15',
    closed: 'bg-zinc-500/20 text-zinc-400 border border-zinc-500/30',
    closing: 'bg-orange-500/20 text-orange-400 border border-orange-500/20',
  };
  return colors[status] || 'bg-zinc-600 text-zinc-100';
}

export function getConnectionStatusLabel(status) {
  const labels = {
    connected: 'Conectado',
    disconnected: 'Desconectado',
    error: 'Erro',
    requires_reconnection: 'Requer Reconexão',
  };
  return labels[status] || status;
}

export function getConnectionStatusColor(status) {
  const colors = {
    connected: 'text-green-400',
    disconnected: 'text-zinc-400',
    error: 'text-red-400',
    requires_reconnection: 'text-yellow-400',
  };
  return colors[status] || 'text-zinc-400';
}

export function truncate(str, length = 50) {
  if (!str) return '';
  return str.length > length ? str.substring(0, length) + '...' : str;
}

export function getInitials(name) {
  if (!name) return '?';
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .substring(0, 2);
}
